import {useState} from "react";
import Image from "next/image";
import Stars from "@/components/base/Stars";
import {getColor} from "@/styles/ThemeConfig";

export default function CityReviewsSection({ logos, rating, ratingSubtitle, reviews }) {
    const [showAllReviews, setShowAllReviews] = useState(false);

    // Define the number of reviews to show initially
    const initialReviewsCount = 5;

    // Function to toggle showing more reviews
    const handleShowMore = () => {
        setShowAllReviews(!showAllReviews);
    };

    // Determine how many reviews to display
    const reviewsToDisplay = showAllReviews ? reviews : reviews.slice(0, initialReviewsCount);

    return (
        <div className={'container_small_with_padding_20'} style={{ paddingBottom: '120px' }}>
            <div style={{
                padding:'0 20px',
            }}>
                <h2 style={{fontSize: '25px', fontFamily: 'Josefin Sans'}}>Reviews from</h2>

                <div>
                    {logos?.map((item, index) => (
                        <Image
                            key={index}
                            src={item?.url}
                            alt={item?.alt ?? item?.name}
                            width={150}
                            height={60}
                            style={{objectFit: 'contain', height: 'auto'}}
                        />
                    ))}
                </div>

                <div style={{display: 'flex', gap: '10px', marginBottom: '40px', alignItems: 'center'}}>
                    <div style={{fontSize: '60px', fontWeight: 'bold'}}>{rating ?? '5.0'}</div>
                    <div>
                        <Stars style={{color: getColor('yellow')}} size={40} numOfStars={Math.round(rating ?? 5)}/>
                        <div style={{color: getColor("lightGrayText"), fontSize: '15px'}}>{ratingSubtitle}</div>
                    </div>
                </div>

                <div style={{fontFamily: 'Josefin Sans', display: 'flex', flexDirection: 'column', gap: '40px'}}>
                    {reviewsToDisplay.map((item, index) => (
                        <div key={index} style={{fontSize: '15px', lineHeight: '25px', color: getColor('grayText')}}>
                            <div style={{display: 'flex', gap: '10px', marginBottom: '10px'}}>
                                <Image
                                    src={item?.image?.url}
                                    alt={item?.name}
                                    width={50}
                                    height={50}
                                    style={{borderRadius: '100%', objectFit: 'cover'}}
                                />
                                <div>
                                    <div style={{marginBottom: '5px', fontWeight: 'bold'}}>{item?.name}</div>
                                    <Stars style={{color: getColor('yellow')}} size={20}
                                           numOfStars={Math.round(item?.rating ?? 0)}/>
                                </div>
                            </div>
                            <div style={{fontWeight: 'bold'}}>{item?.title}</div>
                            <div>{item?.description}</div>
                        </div>
                    ))}

                    {/* Show more button */}
                    {reviews.length > initialReviewsCount && (
                        <button
                            onClick={handleShowMore}
                            style={{
                                backgroundColor: getColor('greenText'),
                                width: 'fit-content',
                                color: 'white',
                                border: 'none',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                marginTop: '20px',
                                fontSize: '16px',
                            }}
                        >
                            {showAllReviews ? "Show Less" : "Show More"}
                        </button>
                    )}
                </div>
            </div>

        </div>
    );
}
